var _rect, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoImageDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2232_26185",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 400,
    height: 400
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "#F8F8FA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2232_26185)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -30.7695,
    y: -26.6665,
    width: 494.359,
    height: 426.667,
    fill: "#F8F8FA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168 216.665V232H232V202.565L221.863 188.821C219.253 185.284 213.852 185.66 211.758 189.525L199.37 212.396C197.449 215.943 192.645 216.622 189.817 213.746L183.88 207.709C181.372 205.159 177.206 205.355 174.948 208.129L168 216.665ZM168 210.329L171.846 205.603C175.608 200.981 182.553 200.655 186.731 204.904L192.669 210.941C193.612 211.9 195.213 211.673 195.853 210.491L208.241 187.62C211.73 181.178 220.733 180.551 225.082 186.447L232 195.826V168H168V210.329ZM166 164C164.895 164 164 164.895 164 166V234C164 235.105 164.895 236 166 236H234C235.105 236 236 235.105 236 234V166C236 164.895 235.105 164 234 164H166ZM185 190C187.761 190 190 187.761 190 185C190 182.239 187.761 180 185 180C182.239 180 180 182.239 180 185C180 187.761 182.239 190 185 190ZM185 194C189.971 194 194 189.971 194 185C194 180.029 189.971 176 185 176C180.029 176 176 180.029 176 185C176 189.971 180.029 194 185 194Z",
    fill: "#E0E0E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImageDefault);
export default __webpack_public_path__ + "static/media/noImage_default.af669522a5773d8e21a510fdc8b0252d.svg";
export { ForwardRef as ReactComponent };